import React from 'react';
import { CgChevronDoubleLeft, CgChevronDoubleRight } from 'react-icons/cg';
import styles from './Pagination.module.scss';

interface Props {
  totalPage: number,
  currentPage: number,
  next: () => void,
  previous: () => void,
  onSpecificPage: (...args: any[]) => void, // eslint-disable-line
}
const Pagination: React.FC<Props> = ({
  totalPage, currentPage, next, previous, onSpecificPage,
}) => (
  <div className={styles.container}>
    <div className={`${styles.prev} alignVCenter`} onClick={previous} aria-hidden>
      <CgChevronDoubleLeft />
      {' '}
      <div>Prev</div>
    </div>
    <div className={styles.paginationContainer}>
      {Array.from(Array(totalPage).keys())
        .map((element, index: number) => (
          <div
            key={element}
            role="button"
            tabIndex={0}
            onKeyDown={() => onSpecificPage(index)}
            onClick={() => onSpecificPage(index)}
            className={currentPage === index ? styles.active : ''}
          >
            {element + 1}
          </div>
        ))}
    </div>
    <div className={`${styles.next} alignVCenter`} onClick={next} aria-hidden>
      <div>Next</div>
      <CgChevronDoubleRight />
    </div>
  </div>
);

export default Pagination;
